export const useRadio = ({ onChange, disabled }) => {
  const handleChange = (e) => {
    if (disabled) return;
    if (onChange) {
      onChange(e);
    }
  };

  return {
    handleChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Radio/hooks/useRadio.js